import React from 'react';

// Partnership Management - Teachers (User Management CSS)
const TeachersTab = () => {
  return (
    <div className="tab-content">
      <div className="user-controls">
        <div className="search-box">
          <input type="text" placeholder="Search teachers" />
          <span className="material-icons">search</span>
        </div>
        <select className="partnership-filter-select" defaultValue="all">
          <option value="all">All Statuses</option>
          <option value="active">Active</option>
          <option value="disabled">Disabled</option>
        </select>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Teacher Name</th>
            <th>School</th>
            <th>Students Referred</th>
            <th>Revenue Generated</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Example Teacher</td>
            <td>Example School</td>
            <td>80</td>
            <td>$320</td>
            <td>Active</td>
            <td>
              <div className="action-buttons">
                <button type="button" className="action-btn edit">View Profile</button>
                <button type="button" className="action-btn toggle">Disable</button>
                <button type="button" className="action-btn delete">Contact</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TeachersTab;

